import React from 'react';
import { AlertTriangle } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const RequiredBanner = ({ isPreview, learnerName }) => {
  const bannerText = isPreview
    ? t('practice.role_play.partner_guide.preview_warning')
    : t('practice.role_play.partner_guide.live_guide_warning', {
        name: learnerName,
      });
  return (
    <>
      <div className="d-f ai-c mb-32 alert-warning pos-a w-100p left-0 border-none h-60 c-black">
        <div className="pl-58 d-f">
          <AlertTriangle size={20} />
          <Text className="pl-10 c-black" variant={TEXT_VARIANTS.BODY}>
            {bannerText}
          </Text>
        </div>
      </div>
    </>
  );
};

export default RequiredBanner;
